<template>
  <div class="navbar-container main-menu-content">
    <horizontal-nav-menu-items :items="navMenuItems" />
  </div>
</template>

<script>
import {
  admin,
  teacher,
  student,
  teacherMaster,
  studentMaster,
} from "@/navigation/horizontal";
import HorizontalNavMenuItems from "./components/horizontal-nav-menu-items/HorizontalNavMenuItems.vue";
import Auth from "@/Apis/Auth";

export default {
  components: {
    HorizontalNavMenuItems,
  },
  async created() {
    this.eduPrograms = Auth.EDU_PROGRAMS;
    this.user = Auth.USER;

    this.eduProgram = localStorage.getItem("eduProgram");
    this.rooms = Auth.ROOM.filter((a) => a.edu_program_id == this.eduProgram);
    this.room = localStorage.getItem("room");
    this.master = localStorage.getItem("master");

    switch (Auth.USER.account_type) {
      case "admin":
        this.navMenuItems = admin;
        break;
      case "student":
        if (this.master == 1) {
          this.navMenuItems = studentMaster;
        } else {
          this.navMenuItems = student;
        }
        break;
      case "teacher":
        if (this.master == 1) {
          this.navMenuItems = teacherMaster;
        } else {
          this.navMenuItems = teacher;
        }
        break;
    }
  },

  data() {
    return {
      eduPrograms: [],
      eduProgram: 0,
      navMenuItems: [],
      user: {},
      rooms: [],
      room: 0,
    };
  },
  methods: {
    showRoom() {
      let eduProgram = this.eduPrograms.find((a) => a.id == this.eduProgram);
      return eduProgram.is_course != 1;
    },
    changeEduProgram() {
      localStorage.setItem("eduProgram", this.eduProgram);

      if (this.user.account_type == "teacher") {
        let eduProgram = this.eduPrograms.find((a) => a.id == this.eduProgram);
        if (eduProgram.is_course == 1) {
          localStorage.setItem("room", eduProgram.rooms[0].id);
          this.$router.go(this.$router.currentRoute);
        }
        this.rooms = [];
        this.rooms = Auth.ROOM.filter(
          (a) => a.edu_program_id == this.eduProgram
        );
      } else {
        this.$router.go(this.$router.currentRoute);
      }
    },
    changeRoom() {
      localStorage.setItem("room", this.room);
      this.$router.go(this.$router.currentRoute);
    },
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/horizontal-menu.scss";
</style>
